<div class="flex gap-2.5 desk:flex-wrap">
  @for (filter of filters(); track filter.key) {
    <div
      (click)="onToggle(filter.key)"
      [class.bg-anis]="filtersSelected().has(filter.key)"
      class="cursor-pointer select-none text-nowrap rounded-xl border-2 px-4 py-3 font-medium">
      {{ filter.label }}
    </div>
  }
</div>
